module.exports = __webpack_public_path__ + "static/img/ad.43af716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/ad.png
// module id = HYb7
// module chunks = 12